const responseError = (e) => {
    if (e && e.response && e.response.data && e.response.data.message) {
        return e.response.data.message
    } else if (e && e.response && e.response.data) {
        return e.response.data
    }
}

module.exports = {
    responseError
}